import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["watch-vo2max"]!;

export function Body() {
  return (
    <>
      <p>
        Many running watches give you a VO₂max number, and it is tempting to follow it closely.
        A review of the research shows how close those numbers get to a real lab test, and
        where they fall short.
      </p>

      <h2>What the researchers did</h2>
      <p>
        An international network of researchers, INTERLIVE, collected 14 studies that compared
        VO₂max estimated by consumer wearables with VO₂max measured in a lab. They pooled the
        results and looked at how far off the watches were, both on average and for the
        individual person.
      </p>

      <h2>What they found</h2>
      <p>
        The method mattered. Devices that estimate VO₂max from resting data overestimated it by
        about 2 ml/kg/min on average, and for an individual the error could be much larger.
      </p>
      <p>
        Devices that use data from exercise, such as heart rate and speed during a run, were
        right on average. For the individual, though, the estimate could still be up to about
        10 ml/kg/min too high or too low. If your watch says 50, your real value could be
        somewhere around 40 or 60.
      </p>

      <h2>What it means for you</h2>
      <p>
        Use the number as a trend, not as a measurement. Compare it over months, with the same
        watch, and mostly from similar runs. Don't compare it with friends who use another
        brand, and don't change your training because the number moved by one or two points.
      </p>
      <p>
        A race or a well-run test says more about your current fitness than a watch estimate.
      </p>

      <h2>What the study can't tell you</h2>
      <p>
        The review covers the devices and algorithms that had been tested by then. Newer models
        may do better or worse. The researchers also called for better and more consistent
        testing of these features.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training sets your targets from your races, tests and runs, not from the watch's
        VO₂max. A higher number on your watch does not on its own make your training harder.
      </p>

      <h2>Source</h2>
      <ul>
        <li>
          Molina-Garcia et al. (2022), Validity of estimating the maximal oxygen consumption by
          consumer wearables: a systematic review with meta-analysis and expert statement of the
          INTERLIVE network.{" "}
          <a href="https://doi.org/10.1007/s40279-021-01639-y">Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
